<template>
    <v-container class="pa-6">
      <div class="holder">
        <h1 id="page-header"><router-link to="/">Tax Estimators</router-link></h1>
        <div id="blurb">
          <p>
            Use the calculator to estimate personal property or check against your bill.
          </p>
          <br/>
        </div>
      </div>
      <div class="layer-page">
        <div class="widget" style="margin: 0 8px">
          <div>
            <h2 class="text-h6">
              <router-link to="/vpp">Vehicle Personal Property Tax Estimator</router-link>
            </h2>
          </div>
          <br/><br/>
        </div>
      </div>
    </v-container>
  </template>
  
  <script>
  
  export default {
  
  }
  
  </script>
  